<template>
  <div>
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper" v-loading="loading">
      <el-row>
        <div class="mask" v-if="isMask"></div>
        <div class="title" style="margin-top: 20px;">
          <i @click="collClick('orderShow1')" style="cursor: pointer;" :class="[orderShow1 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
          <span @click="collClick('orderShow1')" style="cursor: pointer;">活动主题信息</span>
        </div>
        <div class="card-box" v-show="orderShow1">
            <div class="card is-hover-shadow" >
            <div class="left" v-if="activityInfo.themeInfoDTO">
                <div class="left-top">
                    <div class="left">
                        <div class="top-name">{{activityInfo.themeInfoDTO.themeName}}</div>
                        <div class="top-sign">{{getBluename(activityInfo.themeInfoDTO.orgLevel)}}</div>
                    </div>
                    <div class="right">
                            <span>{{getTime(activityInfo.themeInfoDTO.themeStartTime)}}</span>
                            <span style="margin:0px 10px;">-</span>
                            <span>{{getTime(activityInfo.themeInfoDTO.themeEndTime)}}</span>
                        </div>
                </div>
                <div class="pr-item-flex" v-if="activityInfo.themeInfoDTO.gpPrDTOList">
                  <div style="margin-right:50px;margin-top:12px;"> <span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
                  <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
                </div>
                <div class="left-third">
                    <div class="left-third-left">
                        <span>活动执行数据收集模板</span>
                        <span @click="viewChangepop()" style="color: #409EFF;margin-left: 20px;cursor: pointer;">配置详情</span>
                    </div>
                    <div class="left-third-right">
                        <span class="text">活动执行手册</span>
                        <span  class="text" style="color: #409EFF;margin-left: 20px;cursor: pointer;">
                            <span @click="viewPdf(activityInfo.themeInfoDTO.manualFileUri)" v-if="activityInfo.themeInfoDTO.manualFileName && activityInfo.themeInfoDTO.manualFileUri">{{ activityInfo.themeInfoDTO.manualFileName }}</span>
                            <span v-else>暂无附件</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="title" style="margin-top: 20px;">
            <i @click="collClick('orderShow2')" style="cursor: pointer;" :class="[orderShow2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
            <span @click="collClick('orderShow2')" style="cursor: pointer;">活动配置信息</span>
        </div>
        <div class="card-box2 is-hover-shadow" v-show="orderShow2">
            <div class="form">
                <div class="item">
                    <div class="item-left">活动渠道</div>
                    <div class="item-right">
                        <span>{{activityInfo.themeChannelName}}</span>
                    </div>
                </div>
                <div class="item">
                    <div class="item-left">活动形式</div>
                    <div class="item-right">{{ activityInfo.themeStyleName }}</div>
                </div>
                <div class="item">
                    <div class="item-left">活动级别</div>
                    <div class="item-right" v-if="activityInfo.themeLevelName">{{activityInfo.themeLevelName}}</div>
                    <div class="item-right" v-else>暂无</div>
                </div>
                <div class="item" v-if="activityInfo.themeInfoDTO">
                    <div class="item-left">活动时间</div>
                    <div class="item-right" style="display: flex;justify-content: space-between;">
                      <div style="width:80%">
                        <span>{{getTime(activityInfo.themeInfoDTO.themeStartTime)}}</span>
                        <span style="margin:0px 10px;">至</span>
                        <span>{{getTime(activityInfo.themeInfoDTO.themeEndTime)}}</span>
                      </div>
                      <div  @click="collClick('orderShow4')" style="flex:1;color:#409EFF;text-align:left;cursor: pointer;">
                        <span v-if="!orderShow4">查看更多</span>
                        <span v-else>收起</span>
                      </div>
                  </div>
                </div>
            </div>
            <div class="form" style="display:block" v-show="orderShow4">
                <div class="item-sign" v-if="activityInfo.gpThemeDetailDTO">
                    <div class="sign">
                        <div class="sign-left">场勘</div>
                        <div class="sign-right">
                            <i v-if="activityInfo.gpThemeDetailDTO.needVerify == 1" class="el-icon-success color-green"></i>
                            <i v-else class="el-icon-error color-red "></i>
                        </div>
                    </div>
                    <div class="sign">
                        <div class="sign-left">搭建</div>
                        <div class="sign-right">
                            <i v-if="activityInfo.gpThemeDetailDTO.needConstruct == 1" class="el-icon-success color-green"></i>
                            <i v-else class="el-icon-error color-red"></i>
                        </div>
                    </div>
                    <div class="sign">
                        <div class="sign-left">临促</div>
                        <div class="sign-right">
                            <i v-if="activityInfo.gpThemeDetailDTO.needSpr == 1" class="el-icon-success color-green"></i>
                            <i v-else class="el-icon-error color-red"></i>
                        </div>
                    </div>
                    <div class="sign">
                        <div class="sign-left">转场</div>
                        <div class="sign-right">
                            <i v-if="activityInfo.gpThemeDetailDTO.needTransitions == 1" class="el-icon-success color-green"></i>
                            <i v-else class="el-icon-error color-red"></i>
                        </div>
                    </div>
                </div>
                <div class="item" style="width:100%" v-if="getDecorates('all')">
                    <div class="item-left">点位照片</div>
                    <div class="item-right" >
                        <span>{{getDecorates('all')}}</span>
                    </div>
                </div>
            </div>
            <div class="form" v-show="orderShow4">
                <div class="item" v-if="activityInfo.gpThemeDetailDTO">
                    <div class="item-left">单场投入预算</div>
                    <div class="item-right" v-if="activityInfo.gpThemeDetailDTO.investUnit">{{formatPrice(activityInfo.gpThemeDetailDTO.investUnit)}}</div>
                    <div class="item-right" v-else>暂无</div>
                </div>
                <div class="item" v-if="activityInfo.gpThemeDetailDTO && activityInfo.gpThemeDetailDTO.needTransitions == 1">
                    <div class="item-left">道具数量</div>
                    <div class="item-right">{{formatPrice(activityInfo.gpThemeDetailDTO.itemQuantity)}}</div>
                </div>
                <div class="item" v-else>
                    <div class="item-left" v-if="activityInfo.gpThemeDetailDTO">
                        <span v-if="activityInfo.gpThemeDetailDTO.pocRelateType == '1'">每售点执行天数</span>
                        <span v-if ="activityInfo.gpThemeDetailDTO.pocRelateType == '2'">每街区执行天数</span>
                        <span v-if ="activityInfo.gpThemeDetailDTO.pocRelateType == '0'">每活动地点执行天数</span>
                    </div>
                    <div class="item-right" v-if="activityInfo.gpThemeDetailDTO">
                        <span>{{formatPrice(activityInfo.gpThemeDetailDTO.perExecDays)}}</span>
                        <span style="margin:0px 0px;">天</span>
                    </div>
                </div>
                <div class="item" v-if="activityInfo.gpThemeDetailDTO&&activityInfo.gpThemeDetailDTO.needSpr==1">
                    <div class="item-left">临促人员人数限制</div>
                    <div class="item-right" v-if="activityInfo.gpThemeDetailDTO.pgQtyLimit">{{ formatPrice(activityInfo.gpThemeDetailDTO.pgQtyLimit) }}</div>
                    <div class="item-right" v-else>暂无</div>
                </div>
                <div class="item" v-if="activityInfo.gpThemeDetailDTO&&activityInfo.gpThemeDetailDTO.needSpr==1">
                    <div class="item-left">打卡/执行信息上传方式</div>
                    <div class="item-right" v-if="activityInfo.gpThemeDetailDTO.needPerformance == 1">督导统一上传</div>
                    <div class="item-right" v-else>临促人员自行上传</div>
                </div>
                <div class="item" v-if="activityInfo.gpThemeDetailDTO" style="width:100%">
                    <div class="item-left">活动SKU</div>
                    <div class="item-right" >
                        <!-- <span>{{getSKU(activityInfo.gpThemeDetailDTO.skuDTOList,'、')}}</span> -->
                        <span v-if=" activityInfo.gpThemeDetailDTO.skuDTOList && activityInfo.gpThemeDetailDTO.skuDTOList.length > 0">
                            <el-tag
                                style=" margin:0 10px 8px 0px;cursor: pointer;"
                                v-for="tag in  activityInfo.gpThemeDetailDTO.skuDTOList"
                                :key="tag.skuCode"
                                type="info">
                                {{tag.skuName}}
                            </el-tag>
                        </span>
                        <span v-else>暂无数据</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="title" style="margin-top: 20px;">
            <i @click="collClick('orderShow5')" style="cursor: pointer;" :class="[orderShow5 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
            <span @click="collClick('orderShow5')" style="cursor: pointer;">提报售点</span>
        </div>
        <div class="sale-place" v-show="orderShow5">
          <div class="sale-place-card2 is-hover-shadow" v-if="activityInfo.gpThemeDetailDTO">
            <div class="div-time" >
              <div class="time-left">活动执行日期</div>
              <div class="time-right">
                <span>{{ getTimename(tableList[0].timeList) }}</span>
                <span style="color:#409EFF;margin-left: 10px;">{{ tableList[0].timeList.length }}天</span>
              </div>
            </div>
            <el-table
              ref="multipleTable"
              :data="tableList"
              tooltip-effect="dark"
              style="width: 100%"
              border
              show-header
              :span-method="objectSpanMethod"
              >
              <el-table-column
              align="center"
              width="70"
              show-overflow-tooltip
              label="BU">
              <template slot-scope="scope">
                  <span v-if="scope.row.buName !== null">
                      {{scope.row.buName.split('|')[0] }}
                  </span>
              </template>
              </el-table-column>
              <el-table-column
              align="center"
              label="销售大区"
              width="100"
              show-overflow-tooltip
              >
              <template slot-scope="scope">
                  <span v-if="scope.row.regionName !== null">
                      {{scope.row.regionName.split('|')[0] }}
                  </span>
              </template>
              </el-table-column>
              <el-table-column
              v-if="activityInfo.gpThemeDetailDTO.pocRelateType !== '0'"
              align="center"
              prop="cityName"
              label="城市"
              width="100"
              show-overflow-tooltip>
              </el-table-column>
              <el-table-column
              v-if="activityInfo.gpThemeDetailDTO.pocRelateType == '0'"
              align="center"
              label="城市"
              width="100"
              show-overflow-tooltip>
              <template slot-scope="scope">
                  <span v-if="scope.row.areaName">
                      {{scope.row.areaName.split('|')[0] }}
                  </span>
              </template>
              </el-table-column>
              <el-table-column
              align="center"
              v-if="activityInfo.gpThemeDetailDTO.pocRelateType == '0' || activityInfo.gpThemeDetailDTO.pocRelateType == '2'"
              :label="activityInfo.gpThemeDetailDTO.pocRelateType == '0' ? '活动地点':'街区名称'"
              show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.blockName }}</template>
              </el-table-column>
              <el-table-column
              v-if="activityInfo.gpThemeDetailDTO.pocRelateType !== '0'"
              align="center"
              label="售点信息"
              show-overflow-tooltip
              >
                  <template slot-scope="scope">
                      <!-- class="store-name" @click="clickStorename(scope.row)" -->
                      <div style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">
                          <span>{{ scope.row.pocName }} </span>
                          <span v-if="scope.row.pocName && scope.row.pocAddress">-</span>
                          <span v-if="scope.row.pocAddress"> {{ scope.row.pocAddress }}</span>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column
              v-if="activityInfo.gpThemeDetailDTO.pocRelateType !== '0'"
              align="center"
              label="联系人信息"
              show-overflow-tooltip
              width="100"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.contactPerson }}</span>
                  <span v-if="scope.row.contactPhone && scope.row.contactPerson">-</span>
                  <span v-if="scope.row.contactPhone">{{ scope.row.contactPhone }}</span>
                </template>
              </el-table-column>
              <el-table-column
              v-if="activityInfo.gpThemeDetailDTO.pocRelateType == '0'"
              align="center"
              prop="blockAddress"
              label="地址"
              show-overflow-tooltip>
              </el-table-column>
              <el-table-column
              align="center"
              prop="bwContactPerson"
              label="百威联系人"
              width="100"
              show-overflow-tooltip>
              </el-table-column>

              <!-- <el-table-column
              v-if="activityInfo.gpThemeDetailDTO.pocRelateType == '2'"
              align="center"
              label="退回标记"
              width="80"
              >
                <template slot-scope="scope">
                  <div  v-if="(scope.row.rejectStatus !== null)">
                      <img style="width:20px" src="../../assets/images/gameplan-return.png" alt="">
                  </div>
                  <div v-else>
                      <img style="width:20px" src="../../assets/images/gameplan-return2.png" alt="">
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column
              align="center"
              label="提报状态"
              width="110"
              show-overflow-tooltip>
              <template slot-scope="scope">
                  <div>
                      <span v-if="scope.row.activityStatus == 0">待提交</span>
                      <span v-else-if="scope.row.activityStatus == 100">Region审批</span>
                      <span v-else-if="scope.row.activityStatus == 200">BU审批</span>
                      <span v-else-if="scope.row.activityStatus == 300">HQ审批</span>
                      <span v-else-if="scope.row.activityStatus == 350">待供应商确认</span>
                      <span v-else-if="scope.row.activityStatus == 400">执行中</span>
                      <span v-else-if="scope.row.activityStatus == 500">已完成</span>
                      <span v-else-if="scope.row.activityStatus == 900">已关闭</span>
                      <span v-else-if="scope.row.activityStatus == 1000">
                          <!-- HQ/BU退回 -->
                          <span v-if="scope.row.rejectClientLevel == 'hq'">
                              HQ退回
                          </span>
                          <span v-else-if="scope.row.rejectClientLevel == 'bu'">
                              BU退回
                          </span>
                          <span v-else>
                              HQ/BU退回
                          </span>
                      </span>
                      <span v-else>未知</span>
                  </div>
              </template>
              </el-table-column>
              <!-- <el-table-column
              align="center"
              label="退回人"
              width="80"
              show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.rejectClientName">{{scope.row.rejectClientName}}</span>
                  <span v-else>暂无数据</span>
                </template>
              </el-table-column>
              <el-table-column
              align="center"
              label="退回理由"
              show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.submitRejectReason">{{scope.row.submitRejectReason}}</span>
                  <span v-else>暂无理由</span>
                </template>
              </el-table-column> -->
          </el-table>
          </div>
        </div>
        <!-- 照片审批进度 -->
        <div   class="photo-approval" v-if="activityInfo.imageApprovalList && activityInfo.imageApprovalList.length > 0">
          <div class="title" ref="targetLocation">
            <div class="title-left" @click="goTar()">活动照片审批记录</div>
             <div class="btn-all" v-show="allShowBtn">
                <DialogPop
                  @confirm="rejectAll"
                  @getRejectaccount="getRejectaccount"
                  :isReject="true"
                  :marLeft="true"
                  isType="1"
                  btnText="全部退回"
                  centerText="是否确认全部退回？"
                ></DialogPop>
                <DialogPop
                  @confirm="agreeAll"
                  isType="0"
                  btnText="全部通过"
                  centerText="是否全部确认通过？"
                >
                </DialogPop>
              </div>
          </div>
          <div v-for="approval in activityInfo.imageApprovalList"
            :key="approval.imageApprovalId"
            class="photo-approval-card is-hover-shadow"
            :class="{ 'photo-approval-card-selected': checkApprovalSelected(approval) }">
            <el-row>
              <el-col :span="16">
                <div class="approval-request-time">
                  提交时间：{{ getDateTime(approval.requestTime) }}
                </div>
              </el-col>
              <el-col :span="8" class="approval-code">
                <span>
                  申请单号：{{ approval.imageApprovalCode }}
                </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <PhotoStep :active="getActivestep(approval)" :stepList="stepList"></PhotoStep>
              </el-col>
              <el-col :span="4" class="approval-view-link">
                <span @click="viewApprovalImage(approval)">查看照片详情</span>
              </el-col>
            </el-row>
            <!-- :stepFunction="stepFunction" -->

          </div>
        </div>

        <div class="photo-fieldBuild" v-for="itemType in imageApprovalInfo.responseImageList" :key="itemType.imageType">
          <div class="title">
            <div class="left">{{ itemType.imageTypeName }}</div>
            <div class="right">
              <span v-if="imageApprovalInfo.evidenceStatus == 500">已审批</span>
              <span v-else-if="imageApprovalInfo.evidenceStatus == 0 || imageApprovalInfo.evidenceStatus == 900">待提交</span>
              <span v-else>审批中</span>
            </div>
          </div>
          <div v-if="itemType.imageType == '01'" class="photo-fieldBuild-card1 is-hover-shadow">
            <div class="card-item" v-for="itemDecorate1 in itemType.activityImageList" :key="itemDecorate1.decorateType">
              <div class="top">{{ itemDecorate1.decorateTypeName }}</div>
              <div class="photo">
                <div class="photo-item" v-for="itemImage,index1 in itemDecorate1.imageList" :key="itemImage.activityImageId">
                  <el-image  :initial-index="index1" :src="getImgList(itemDecorate1.imageList)[index1]" :preview-src-list="getImgList(itemDecorate1.imageList)" class="photo-item-image" />
                  <!-- <img class="photo-item-image" @click="clickImg('/' + itemImage.imageUri,itemDecorate1.imageList,index1)" :src="getImg('/' + itemImage.imageUri)" alt=""> -->
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="itemType.imageType == '02'" class="photo-fieldBuild-card2 is-hover-shadow">
            <div class="card-item" v-for="itemDecorate2 in itemType.activityImageList" :key="itemDecorate2.decorateType">
              <div class="top">{{ itemDecorate2.decorateTypeName }}</div>
              <div class="photo">
                <div class="photo-item" v-for="itemImage,index2 in itemDecorate2.imageList" :key="itemImage.activityImageId">
                  <el-image  :initial-index="index2" :src="getImgList(itemDecorate2.imageList)[index2]" :preview-src-list="getImgList(itemDecorate2.imageList)" class="photo-item-image" />
                  <!-- <img class="photo-item-image" @click="clickImg('/' + itemImage.imageUri,itemDecorate2.imageList,index2)" :src="getImg('/' + itemImage.imageUri)" alt=""> -->
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="photo-fieldBuild-card2 is-hover-shadow" v-for="itemDate in itemType.activityImageList" :key="itemDate.activityDate">
              <div class="execution-time">
                执行时间：{{ itemDate.activityDate }}
              </div>
              <div
                class="card-item"
                v-for="itemDecorate3 in itemDate.activityImageList"
                :key="itemDecorate3.decorateType"
              >
                <div class="top">{{ itemDecorate3.decorateTypeName }}</div>
                <div class="photo">
                  <div
                    class="photo-item"
                    v-for="itemImage,index3 in itemDecorate3.activityImageList"
                    :key="itemImage.activityImageId"
                  >
                    <el-image  :initial-index="index3" :src="getImgList(itemDecorate3.activityImageList)[index3]" :preview-src-list="getImgList(itemDecorate3.activityImageList)" class="photo-item-image" />
                    <!-- <img class="photo-item-image" @click="clickImg('/' + itemImage.imageUri,itemDecorate3.activityImageList,index3)" :src="getImg('/' + itemImage.imageUri)" alt=""> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="photo-bottom" v-if="canApprove">
          <DialogPop
            @confirm="reject"
            @getRejectaccount="getRejectaccount"
            :marLeft="true"
            isType="1"
            btnText="退回"
            centerText="是否确认退回？"
            :isReject="true"
          ></DialogPop>
          <DialogPop
            @confirm="agree"
            isType="0"
            btnText="通过"
            centerText="是否确认通过？"
          >
          </DialogPop>
        </div>
        <!-- @closeClick="()=>{photoVisible=false}" -->
        <!-- <BigImg :visible="photoVisible" :url="bigImgUrl"  :imageList="imgBiglist" :imgIndex="imgIndex"  @closeClick="()=>{photoVisible=false}" >
        </BigImg> -->
        <div v-if="showChangepop" class="changePop">
          <configBuChangePop
          @closeChangepop="closeChangepop"
          :themeId="activityInfo.themeInfoDTO.themeId"
          ></configBuChangePop>
        </div>
        <!-- 提报数据查看详情 -->
        <div v-if="isShowDetail">
          <reportConfigPop @closeChangepop="closeChangepop" :themeDetail="themeDetail" :params="paramsPop"></reportConfigPop>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { commonUtils } from "@/utils/common";
import ContentHeader from "@/components/content-header";
import gameplanApi from "../../api/gameplan";
import PhotoStep from "./components/photo-step";
import DialogPop from "./components/dialog-pop.vue";
import BigImg from './components/big-img.vue'
import configBuChangePop from './components/config-buChange-pop.vue'
import reportConfigPop from './components/report-config-pop.vue';


export default {
  name: "activityPhoto-salePlace-detail",
  components: {
    ContentHeader,
    PhotoStep,
    DialogPop,
    BigImg,
    configBuChangePop,
    reportConfigPop
  },
  data() {
    return {
      stepList: [],
      activityId: "",
      detailList: {},
      activityInfo: {
        gpPrDTO: {},
        themeInfoDTO: {},
        gpActivityPocDTOList: [],
        imageApprovalList:[]

      },
      imageApprovalInfo: {
        imageApprovalId: '',
        imageApprovalCode: '',
        evidenceStatus: '',
        requestTime: '',
        finishFlag: '',
        firstFlag: '',
        responseImageList: []
      },
      isShowbtn: true,
      loading: false,
      evidenceStatus: "", //进度条状态
      orgLevel:'', // 提报人级别
      photoVisible: false,
      bigImgUrl: "",
      imgBiglist:[],
      imgIndex:0,
      rejectAccount:'',
      isMask: false,
      orderShow1: true,
      orderShow2: true,
      orderShow3: true,
      orderShow4: false,
      orderShow5: true,
      routerType:'',
      investUnit: '', // 单场投入预算
      themeChannelName:'',
      themeStyleName:'',
      themeLevelName:'',
      themeDetail:'',
      themeDetailInfo: {},
      themeBasic: {},
      themeDetailId:'',
      isRegion: false,
      showChangepop: false,
      isShowDetail: false,// 展示查看详情弹窗
      paramsPop: {},
      inventoryList: [], // 商品明细列表
      reportList: [], // 提报列表
      tableList: [],
      streetArr: [],
      streeIndex: 0,
      congfigDetail:null,// 配置信息
      prInfo:'',
      brandInfo:''
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    gameplanLevel () {
      if (!this.userInfo) {
        return ''
      }
      const empLevel = this.userInfo.employeeLevel || 0

      if (empLevel === 90 || empLevel === 100) {
        return 'hq'
      }
      if (empLevel === 60 || empLevel === 70 || empLevel === 80) {
        return 'bu'
      }
      if (empLevel === 45 || empLevel === 50) {
        return 'region'
      }
      return ''
    },
    canApprove() {
      const evidenceStatus = this.imageApprovalInfo.evidenceStatus
      if (this.gameplanLevel === 'region' && evidenceStatus === 200) {
        return true
      }
      if (this.gameplanLevel === 'bu' && evidenceStatus === 300) {
        return true
      }
      if (this.gameplanLevel === 'hq' && evidenceStatus === 400) {
        return true
      }
      return false
    },
    allShowBtn() {
      if (this.activityInfo.imageApprovalList == null) {
        return false
      } else {
        let arr = []
        for (let item of this.activityInfo.imageApprovalList) {
          if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
            arr.push(item)
          }
        }
        if (arr.length > 0) {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if(this.userInfo.employeeLevel === 50 || this.userInfo.employeeLevel === 45){
        this.isRegion = true
      }
      this.activityId = this.$route.query.activityId
      this.getActivityInfo()
      // this.getConfigfull()
    },
    // 金额千分
    formatPrice(price) {
        return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    goTar () {
      const targetLocation = this.$refs.targetLocation
      // console.log(targetLocation,'targetLocation');
      targetLocation.scrollIntoView()
      // targetLocation.scrollIntoView({ behavior: "smooth"})
    },
    getTimename (timeListno) {
      // let  timeListno = ['2023-04-20','2023-04-22','2023-04-23','2023-04-24','2023-04-25']
      if (timeListno) {
          let name = ''
          name = timeListno.map((item)=>{
              return item.activityTime
          }).join(' | ')
          return name
      } else {
          return 'null'
      }
    },
    // 获取提报信息
    async getReportdetail(params) {
      let data = await gameplanApi.getReportdetail(params);
      if (data.data.resultCode == "0") {
        this.isMask = true
        this.isShowDetail = true
        this.lockScroll()
      }
    },
    //售点查看详情
    viewDetail (row) {
      let params = {
          activityId: row.activityId,
          activityTime: row.timeSign,
          pocAbiId: row.igniteId
      }
      this.getReportdetail(params)
      this.paramsPop = params
    },
    lockScroll() {
      let widthBar = 17, root = document.documentElement;
      if (typeof window.innerWidth == 'number') {
          widthBar = window.innerWidth - root.clientWidth;
      }
      root.style.overflow = 'hidden';
      root.style.borderRight = widthBar + 'px solid transparent';
    },
    unlockScroll() {
      let root = document.documentElement;
      root.style.overflow = '';
      root.style.borderRight = '';
    },
    viewPdf (url) {
      if (url) {
          window.open(commonUtils.getImageUrl(url))
      } else {
          console.log('manualFileUri为空');
      }
    },
    viewChangepop () {
      this.isMask = true
      this.showChangepop = true
      this.lockScroll()
    },
    closeChangepop () {
      this.isMask = false
      this.showChangepop = false
      this.isShowDetail = false
      this.unlockScroll()
    },
    getSKU (arr,sign) {
      if (arr && arr.length > 0) {
          let name = arr.map((item)=>{
          return item.skuName
          }).join(sign)
          return name
      } else {
          return '暂无数据'
      }
    },
    // 获取配置信息
    async getConfigfull () {
        let {data} = await gameplanApi.getGameplanConfigFull()
        if (data.resultCode == '0') {
            let fullConfig = data.resultData.fullConfig
            for (let item1 of fullConfig) {
                if (item1.themeChannelCode == this.themeDetail.themeChannelCode) {
                    for (let item2 of item1.themeStyles) {
                        if (item2.themeStyleCode == this.themeDetail.themeStyleCode) {
                            if (this.themeDetail.themeLevelCode && item2.themeLevels.length > 0) {
                                for (let item3 of item2.themeLevels) {
                                    if (item3.themeLevelCode == this.themeDetail.themeLevelCode) {
                                        this.congfigDetail = item3.themeConfig
                                    }
                                }
                            } else {
                                this.congfigDetail = item2.themeConfig
                            }
                        }
                    }
                }
            }
        }
    },
    // 获取点位信息
    getDecorates (type) {
      if (!this.activityInfo.gpThemeDetailDTO) {
        return
      }
        let data = this.activityInfo.gpThemeDetailDTO.themeDecorates
        let showDecorates = []
        let showExecDecorates = []
        if (data) {
          if (type == 'showDecorates') {
              if (showDecorates.length > 0) {
                  let name = showDecorates.map((item)=>{
                      return item.decorateName
                  }).join('、')
                  return name
              } else {
                  return false
              }
          } else if (type == 'showExecDecorates') {
              if (showExecDecorates.length > 0) {
                  let name = showExecDecorates.map((item)=>{
                      return item.decorateName
                  }).join('、')
                  return name
              } else {
                  return false
              }
          } else if (type == 'all') {
              if (data.length > 0) {
                  let name = data.map((item)=>{
                      return item.decorateName
                  }).join('、')
                  return name
              } else {
                  return false
              }
          } else {
              return
          }
        } else {
            return ''
        }
    },
    getpocRelateType (gpThemeDetailDTO) {
        let pocRelateType = gpThemeDetailDTO.pocRelateType
        if (pocRelateType == 0) {
            return this.saleTypename = '无售点'
        }else if (pocRelateType == 1) {
            return this.saleTypename = '单售点'
        } else if (pocRelateType == 2) {
            return this.saleTypename = '多售点'
        } else {
            return this.saleTypename = 'error'
        }
    },
    getRegionName (item) {
        if (item) {
            if (this.isRegion) {
                return item.regionName.split('|')[0] + ":"
            } else {
                return item.buName.split('|')[0] + ":"
            }
        }else {
            return '无'
        }
    },
    getBluename (name) {
        if (name == 'region') {
            return 'Region'
        } else if (name == 'bu') {
            return 'BU'
        } else if (name == 'hq') {
            return 'HQ'
        } else {
            return 'error'
        }
    },
    // 明细显示隐藏
    collClick (name) {
      if (name == 'orderShow1') {
          this.orderShow1 = !this.orderShow1
      } else if (name == 'orderShow2') {
          this.orderShow2 = !this.orderShow2
      } else if (name == 'orderShow3') {
          this.orderShow3 = !this.orderShow3
      } else if (name == 'orderShow4') {
          this.orderShow4 = !this.orderShow4
      } else if (name == 'orderShow5') {
          this.orderShow5 = !this.orderShow5
      }
    },
    // 初始化合并行数组
    mergeInit() {
      this.streetArr = []; //合并街道
      this.streeIndex = 0; //合并街道索引
    },
//  合并表格
    merge(data) {
        this.mergeInit();
        if (data.length > 0 && this.activityInfo.gpThemeDetailDTO.pocRelateType == '2') {
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    //第一行必须存在，以第一行为基准
                    this.streetArr.push(1); //合并医院
                    this.streeIndex = 0;
                } else {
                    // 判断当前元素与上一元素是否相同
                    // 合并街区列
                    if (data[i].blockName == data[i - 1].blockName) {
                    this.streetArr[this.streeIndex] += 1;
                    this.streetArr.push(0);
                    } else {
                    this.streetArr.push(1);
                    this.streeIndex = i;
                    }
                }
            }
        }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const len = this.tableList.length;
      if (this.activityInfo.gpThemeDetailDTO.pocRelateType == '2') {
        if (columnIndex === 0 ||columnIndex === 1 ||columnIndex === 2 || columnIndex === 3 || columnIndex === 6 || columnIndex === 7 ||  columnIndex === 8 || columnIndex === 9 || columnIndex === 10 ) {
          const _row_1 = this.streetArr[rowIndex];
          const _col_1 = _row_1 > 0 ? 1 : 0;
          return {
          rowspan: _row_1,
          colspan: _col_1,
          };
        }
      }
    },
    // 理由
    getRejectaccount (val) {
      this.rejectAccount = val
    },
    isMultiPoc(activity) {
      if (activity.gpThemeDetailDTO) {
        return activity.gpThemeDetailDTO.pocRelateType
      }
    },
    getImg (uri) {
        return commonUtils.getImageUrl(uri)
    },
    clickImg (uri,imgList,index) {
        this.imgIndex = index
        this.imgBiglist = imgList
        this.photoVisible = true
        this.bigImgUrl =  commonUtils.getImageUrl(uri)
    },
    // getUserlevel() {
    //   if (this.employeeLevel == 35) {
    //     this.gameplanLevel = 4;
    //     this.active = 1;
    //   } else if (
    //     this.employeeLevel == 40 ||
    //     this.employeeLevel == 45 ||
    //     this.employeeLevel == 50
    //   ) {
    //     this.gameplanLevel = 3;
    //     this.active = 1;
    //   } else if (
    //     this.employeeLevel == 60 ||
    //     this.employeeLevel == 70 ||
    //     this.employeeLevel == 80
    //   ) {
    //     this.gameplanLevel = 2;
    //     this.active = 2;
    //   } else if (this.employeeLevel == 90 || this.employeeLevel == 100) {
    //     this.gameplanLevel = 1;
    //     this.active = 3;
    //   } else {
    //     this.gameplanLevel = "未知";
    //   }
    // },
    getTime(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D;
      }
    },
    getDateTime(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D + h + m + s;
      }
    },
    getImgList(dataList) {
      const imgList = []
      if (!dataList) {
        return []
      }
      dataList.forEach(item => {
        imgList.push(this.getImg(item.imageUri))
      })
      return imgList
    },
    getShowDetail(){
      const themeBasic = this.activityInfo.themeInfoDTO || {}
      let brandInfo = []
      let prInfo = []
      const gpPrDTOList = themeBasic.gpPrDTOList
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          let data = ''
          if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
          else data = item.brandName||item.subBrandName
          if(brandInfo.indexOf(data)===-1) {
            brandInfo.push(data)
          }
          prInfo.push(item.prNumber+'-'+item.prName)
        })
        this.brandInfo = brandInfo.join('、')
        this.prInfo = prInfo.join('、')
      }
    },
    async getActivityInfo() {
      let params = {
        activityId: this.activityId,
      };
      this.loading = true
      let res = await gameplanApi.getActivityApprovePhotoInfo(params)
      if (res.data.resultCode === "0") {
          this.activityInfo = res.data.resultData.activityInfo || {}
          this.getShowDetail()
          this.orgLevel =  res.data.resultData.activityInfo.themeInfoDTO?.orgLevel || ''
          if (this.orgLevel == 'hq') {
            this.stepList = [
              {
                name: "",
                index: 1,
                title: "照片待提交",
                title1: "照片提交中",
                title2: "照片已提交",
              },
              {
                name: "",
                index: 2,
                title: "HQ待审批",
                title1: "HQ审批中",
                title2: "HQ已审批",
              },
            ]
          } else if (this.orgLevel == 'bu') {
            this.stepList = [
              {
                name: "",
                index: 1,
                title: "照片待提交",
                title1: "照片提交中",
                title2: "照片已提交",
              },
              {
                name: "",
                index: 2,
                title: "BU待审批",
                title1: "BU审批中",
                title2: "BU已审批",
              }
            ]
          }
          else if (this.orgLevel == 'region') {
            this.stepList = [
              {
                name: "",
                index: 1,
                title: "照片待提交",
                title1: "照片提交中",
                title2: "照片已提交",
              },
              {
                name: "",
                index: 2,
                title: "Region待审批",
                title1: "Region审批中",
                title2: "Region已审批",
              }
            ]
          }
          // console.log( this.activityInfo,' this.activityInfo');
          let activityInfo = this.activityInfo
          let tableList = []
          let gpActivityPocDTOList = activityInfo.gpActivityPocDTOList || []
          let timeList =  activityInfo.gpActivityTimeDTOList || []
          let blockName = activityInfo.blockName
          let buName = activityInfo.buName
          let regionName = activityInfo.regionName
          let activityStatus = activityInfo.activityStatus
          let bwContactPerson = activityInfo.bwContactPerson
          let areaCode = activityInfo.areaCode
          let regionCode =  activityInfo.regionCode
          let submitRejectReason = activityInfo.submitRejectReason
          let rejectClientName = activityInfo.rejectClientName
          let rejectClientLevel = activityInfo.rejectClientLevel
          let blockAddress = activityInfo.blockAddress
          let areaName = activityInfo.areaName
          let obj = {}
          if (this.isMultiPoc(this.activityInfo) == '0') {
            obj.blockName = blockName
            obj.buName = buName
            obj.regionName = regionName
            obj.activityStatus = activityStatus
            obj.bwContactPerson = bwContactPerson
            obj.areaCode = areaCode
            obj.timeList = timeList
            obj.timeListno = timeList
            obj.regionCode = regionCode
            obj.submitRejectReason = submitRejectReason
            obj.rejectClientName = rejectClientName
            obj.rejectClientLevel = rejectClientLevel
            obj.blockAddress = blockAddress
            obj.areaName = areaName
            tableList.push(obj)
          } else {
            for (const item of gpActivityPocDTOList) {
              item.blockName = blockName
              item.buName = buName
              item.regionName = regionName
              item.activityStatus = activityStatus
              item.bwContactPerson = bwContactPerson
              item.areaCode = areaCode
              item.timeList = timeList
              item.timeListno = timeList
              item.regionCode = regionCode
              item.submitRejectReason = submitRejectReason
              item.rejectClientName = rejectClientName
              item.rejectClientLevel = rejectClientLevel
              item.blockAddress = blockAddress
              item.areaName = areaName
              tableList.push(item)
            }
          }
          this.tableList = tableList
          this.merge(this.tableList)
          let that = this
          // console.log(tableList,'tableList');
          setTimeout(function () {
            that.loading = false
            if (that.activityInfo.imageApprovalList && that.activityInfo.imageApprovalList.length > 0) {
              that.goTar()
            }
          },500)
      } else {
        this.loading = false
        console.log("接口error");
      }
    },
    getPhotostatus() {
      let params = {
        name: "gpEvidenceStatusMap",
        type: "map",
      };
      gameplanApi.getGamepalnPhotostatus(params).then((res) => {
        if (res.data.resultCode === "0") {
          // console.log(res.data.resultData, "getPhotostatus-售点详情");
        } else {
          console.log("接口error");
        }
      });
    },
    checkApprovalSelected(approval) {
      return approval.imageApprovalId === this.imageApprovalInfo.imageApprovalId
    },
    getActivestep (approval) {
      const evidenceStatus = approval.evidenceStatus
      if (!evidenceStatus) {
        return 0
      }
      if (evidenceStatus === 0) {
        return 0
      }
      if (evidenceStatus === 100) {
        return 1
      }
      // if (evidenceStatus === 200) {
      //   return 1
      // }
      // if (evidenceStatus === 300) {
      //   return 2
      // }
      // if (evidenceStatus === 400 ) {
      //   return 3
      // }
      // if (evidenceStatus === 500) {
      //   return 4
      // }
      if (evidenceStatus === 200 && this.orgLevel == 'region' ) {
        return 1
      }
      if (evidenceStatus === 300 && this.orgLevel == 'bu' ) {
        return 1
      }
      if (evidenceStatus === 400 && this.orgLevel == 'hq' ) {
        return 1
      }
      if (evidenceStatus === 500) {
        return 2
      }
      return 0
    },
    viewApprovalImage(approval) {
      this.imageApprovalInfo = approval
    },
    // 审批接口
    gamepalnActivityapprove(payload) {
      this.loading = true
      gameplanApi.submitImageApproval(payload).then((res) => {
        this.loading = false
        if (res.data.resultCode === "0") {
          if (payload[0].processAction == "02") {
            this.$message.success("通过成功");
          } else if (payload[0].processAction == "03") {
            this.$message.success("退回成功");
          }
          this.imageApprovalInfo = {
            imageApprovalId: '',
            imageApprovalCode: '',
            evidenceStatus: '',
            requestTime: '',
            finishFlag: '',
            firstFlag: '',
            responseImageList: []
          }
          this.rejectAccount = ''
          this.getActivityInfo()
        } else {
          console.log("error")
        }
      }).catch((err) => {
        this.loading = false
      })
    },
    // 驳回
    reject() {
      let payload = [
        {
          'imageApprovalId': this.imageApprovalInfo.imageApprovalId,
          'processAction': '03',
          'rejectReason':this.rejectAccount,
          'rejectPerson':this.userInfo.clientName,
        }
      ]
      this.gamepalnActivityapprove(payload);
    },
    // 通过
    agree() {
      let payload = [
        {
          'imageApprovalId': this.imageApprovalInfo.imageApprovalId,
          'processAction': '02',
        }
      ]
      this.gamepalnActivityapprove(payload);
    },
    rejectAll () {
      let arr = []
      for (let item of this.activityInfo.imageApprovalList) {
        if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
          arr.push({
          "imageApprovalId": item.imageApprovalId,
          "processAction": "03",
          'rejectReason':this.rejectAccount,
          'rejectPerson':this.userInfo.clientName,
          })
        }
      }
      this.allApprove(arr)
    },
    agreeAll () {
      let arr = []
      for (let item of this.activityInfo.imageApprovalList) {
        if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
          arr.push({
          "imageApprovalId": item.imageApprovalId,
          "processAction": "02"
         })
        }
      }
      this.allApprove(arr)
    },
    allApprove (params) {
      this.loading = true
      gameplanApi.submitImageApproval(params).then((res) => {
        this.loading = false
        if (res.data.resultCode === "0") {
          if (params[0].processAction == "02") {
            this.$message.success("全部通过成功");
          } else if (params[0].processAction == "03") {
            this.$message.success("全部驳回成功");
          }
          this.rejectAccount = ''
          this.$router.go(-1)
        } else {
          console.log("error")
        }
      }).catch((err) => {
        this.loading = false
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  padding-top: 20px;
  .title {
    line-height: 40px;
    text-align: left;
    color: #101010;
    font-size: 18px;
    font-weight: 600;
  }
  .card-box {
    .card {
        display: flex;
        justify-content: flex-start;
        padding:10px  20px;
        background-color: #FFFFFF ;
        border-radius: 10px;
        font-size: 14px;
        .left {
            flex: 1;
            text-align: left;
            color: #101010;
            .left-top {
                display: flex;
                .left {
                    width: 70%;
                    font-size: 18px;
                    display: flex;
                    .top-name {
                        // padding: 2px 0px;
                        font-weight: 600;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                    .top-sign {
                        // padding: 2px 8px;
                        color: #FFFFFF;
                        background-color: #40A5EE;
                        margin-left: 10px;
                        // border-radius: 3px;
                        // height: 20px;
                        padding: 0px 8px;
                        line-height: 18px;
                        height: 18px;
                        font-size: 14px;
                        margin-top: 1px;
                        font-weight: 600;
                    }
                }
                .right {
                    flex: 1;
                    line-height: 20px;
                    font-size: 14px;
                    text-align: right;
                    word-wrap: break-word;
                    word-break: normal;
                    word-break: break-all;
                }
            }
            .fouth {
                font-size: 14px;
                line-height: 20px;
                color: #101010 ;
                margin-top: 15px;
                display: flex;
                .fouth-left {
                    display: flex;
                    .first-center {
                        height: 15px;
                        line-height: 15px;
                        padding: 3px 10px;
                        text-align: center;
                        border-radius: 4px;
                        border: 1px solid #539EFE;
                        background-color: #FFFFFF;
                        color: #539EFE;
                        margin-left: 20px;
                        margin-top: -1px;
                    }
                }
                .fouth-right {
                    // color: #999999 ;
                    flex: 1;
                    margin-left: 50px;

                }
            }
            .left-third {
                font-size: 14px;
                height: 20px;
                line-height: 20px;
                margin-top: 12px;
                display: flex;
                justify-content: flex-start;
                .left-third-left {
                    display: flex;
                    justify-content: flex-start;
                    margin-right: 80px;
                }
                .left-third-right {
                    display: flex;
                    justify-content: flex-start;
                    .img {
                    width: 20px;
                    margin-right: 3px;
                    }
                    // .text {
                    //     margin: 0px 3px 0px 3px ;
                    //     // color: #539EFE;
                    // }
                }
            }
            .left-fouth {
                display: flex;
                font-size: 14px;
                line-height: 20px;
                margin-top: 12px;
                .left-fouth-left {
                    width: 70px;
                }
                .left-fouth-right {
                    flex: 1;
                }
            }
        }
        .right {
            text-align: right;
            .right-top {
                line-height: 27px;
                color: #999999;
                font-size: 16px;
            }
        }
    }
  }
  .card-box2 {
    padding: 10px 20px;
    background-color: #FFFFFF;
    color: #101010;
    border-radius: 10px;
    .form{
        display: flex;
        flex-wrap: wrap;
        padding-left: 8px;
        .item {
            width: 50%;
            line-height: 33px;
            font-size: 14px;
            color: #101010;
            display: flex;
            text-align: left;
            .item-left {
                text-align: right;
                width: 148px;
                font-weight: 600;
                margin-right: 40px;
            }
            .item-right {
                flex: 1;
                word-wrap: break-word;
                word-break: normal;
                word-break: break-all;
            }
        }
        .item-sign {
            line-height: 33px;
            font-size: 14px;
            color: #101010;
            display: flex;
            text-align: left;
            padding-left: 104px;
            .sign {
                display: flex;
                margin: 0px 15px;
                .sign-left {
                    margin-right: 5px;
                    font-weight: normal;
                    line-height: 33px;
                }
                .sign-right {
                    margin-top: 3px;
                    .color-green {
                        color: rgb(42, 219, 33);
                        font-size: 18px;
                    }
                    .color-red {
                        color: rgb(219, 93, 33);
                        font-size: 18px;
                    }
                }
            }
        }
    }
  }
  .card-box3 {
    padding: 10px 20px;
    background-color: #FFFFFF;
    color: #101010;
    border-radius: 10px;
    .form{
        padding-left: 8px;
        .item {
            line-height: 33px;
            font-size: 14px;
            color: #101010;
            display: flex;
            text-align: left;
            .item-left {
                text-align: right;
                width: 148px;
                font-weight: 600;
                margin-right: 40px;
            }
            .item-right {
                flex: 1;
                word-wrap: break-word;
                word-break: normal;
                word-break: break-all;
            }
        }
    }
  }
  .changePop {
    position: fixed;
    top: 5vh;
    left: calc((100vw - 800px)/2);
    width: 800px;
    padding: 20px;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: 3;
    max-height: 90vh;
  }
  .mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7) ;
    z-index: 3;
  }
  .card-top {
    border-radius: 10px;
    padding: 10px 20px;
    margin-bottom: 20px;
    font-size: 14px;
    text-align: center;
    background-color: #ffffff;
    color: #101010;
    font-family: Roboto;
    display: flex;
    justify-content: flex-start;
    .card-top-left {
      flex: 1;
      .top {
        line-height: 29px;
        color: #101010;
        font-size: 20px;
        font-weight: 600;
        text-align: left;
        font-family: SourceHanSansSC-medium;
        margin-bottom: 5px;
        word-wrap: break-word;
        word-break: normal;
        word-break: break-all;
      }
      .bottom {
        display: flex;
        justify-content: flex-start;
        .left {
          font-size: 16px;
          margin-right: 11px;
          line-height: 24px;
        }
        .right {
          width: 72px;
          line-height: 20px;
          margin-top: 2px;
          border-radius: 4px;
          font-size: 14px;
          background-color: #ffffff;
          color: #539efe;
          border: 1px solid #539efe;
          text-align: center;
        }
      }
    }
    .card-top-right {
      width: 30%;
      text-align: right;
      line-height: 20px;
      margin-top: 40px;
      color: #999999;
    }
  }
  .sale-place {
    .div-time {
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      line-height: 40px;
      .time-left {
          width: 150px;
          font-weight: 600;
          text-align: right;
          margin-right: 50px;
      }
      .time-right {
          flex: 1;
          font-size: 14px;
      }
    }
    .title {
      height: 50px;
      line-height: 50px;
      color: #101010;
      font-size: 18px;
      text-align: left;
      font-weight: 600;
      font-family: SourceHanSansSC-bold;
    }
    .sale-place-card {
      padding: 10px 20px;
      background-color: #ffffff;
      border-radius: 10px;
      font-size: 14px;
      text-align: center;
      font-family: Roboto;
      display: flex;
      .left {
        width: 451px;
        .item {
          display: flex;
          font-size: 14px;
          text-align: left;
          line-height: 33px;
          .item-left {
            width: 117px;
            font-weight: 600;
          }
          .item-right {
            flex: 1;
          }
        }
      }
      .right {
        flex: 1;
        font-size: 14px;
        text-align: left;
        .item {
          display: flex;
          // height: 33px;
          line-height: 33px;
          .item-left {
            // width: 152px;
            width: 117px;
            font-weight: 600;
          }
          .item-right {
            flex: 1;
          }
        }
      }
    }
    .sale-place-card2 {
      padding: 10px 20px;
      background-color: #ffffff;
      border-radius: 10px;
      font-size: 14px;
      ::v-deep .el-table th.el-table__cell {
        color: #101010;
        background-color: rgba(232, 232, 232);
      }
      ::v-deep .el-table__body tr.current-row > td.el-table__cell {
        background-color: #ffffff !important;
      }
      ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #ffffff !important;
      }
    }
  }
  .photo-approval {
    margin-top: 20px;
    .title {
      display: flex;
      justify-content: space-between;
      .title-left {
        height: 50px;
        line-height: 50px;
        color: #101010;
        font-size: 18px;
        text-align: left;
        font-weight: 600;
      }
      .btn-all {
        padding-top: 10px;
        padding-bottom: 10px ;
        display: flex;
        justify-content: flex-end;
        height: 32px;
        line-height: 32px;
      }
    }
    .photo-approval-card {
      padding: 20px 20px 30px 20px;
      background-color: #ffffff;
      font-size: 15px;
      border-radius: 10px;
      margin-bottom: 10px;
    }
    .photo-approval-card-selected {
      background-color: #ececec;
    }
    .approval-request-time {
      color: #cd1231;
      font-weight: 700;
      padding: 0 0 20px 0;
      line-height: 32px;
    }
    .approval-code {
      text-align: right;
      font-size: 12px;
      color: #999999;
    }
    .approval-view-link {
      text-align: right;
      color: #cd1231;
      font-weight: 700;
      padding: 30px 0 0 0;
      span {
        cursor: pointer;
      }
    }
  }
  .photo-fieldBuild {
    margin-top: 30px;
    .title {
      line-height: 50px;
      color: #101010;
      font-size: 18px;
      text-align: left;
      font-weight: 600;
      font-family: SourceHanSansSC-bold;
      display: flex;
      .right {
        width: 66px;
        height: 21px;
        line-height: 21px;
        margin-top: 15px;
        border-radius: 4px;
        background-color: #ffeaa6;
        color: #d19f00;
        font-size: 12px;
        text-align: center;
        margin-left: 5px;
      }
    }
    .photo-fieldBuild-card1 {
      padding: 10px 20px;
      background-color: #ffffff;
      font-size: 14px;
      color: #101010;
      position: relative;
      border-radius: 10px;
      .card-item {
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        .top {
          line-height: 30px;
          text-align: left;
        }
      }
    }

    .photo-fieldBuild-card2 {
      padding: 10px 20px;
      background-color: #ffffff;
      font-size: 14px;
      color: #101010;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      border-radius: 10px;
      margin-bottom: 5px;
      .card-item {
        width: 579px;
        font-weight: bold;
        margin-top: 15px;
        .top {
          line-height: 30px;
          text-align: left;
        }
      }
      .execution-time {
        position: absolute;
        top: 5px;
      }
    }
    .photo {
      display: flex;
      flex-wrap: wrap;
      .photo-item {
        margin-right: 10px;
        margin-bottom: 10px;
        width: 100px;
        height: 100px;
        cursor: pointer;
        overflow:hidden;
        max-width: 100px;
        max-height: 100px;
        .photo-item-image {
          width:100%;
          // height:100%;
          background-position:center center;
          background-repeat: no-repeat;
          -webkit-background-size:cover;
          -moz-background-size:cover;
          background-size:cover;
        }
      }
    }
  }
  .photo-bottom {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    height: 32px;
    line-height: 32px;
  }
  .btn-all {
    padding-top: 10px;
    padding-bottom: 10px ;
    display: flex;
    justify-content: flex-end;
    height: 32px;
    line-height: 32px;
  }
}
.pr-item-flex{
    display:flex;
    flex-wrap:wrap;
  }
</style>
